import { FrogMascot, type FrogMascotSize } from './FrogMascot';
import { cn } from '@/lib/utils';

interface LoadingFrogProps {
  /** Message displayed below the frog */
  message?: string;
  /** Frog image size */
  size?: FrogMascotSize;
  /** Fill the full screen height (true) or fit inline (false) */
  fullScreen?: boolean;
  /** Optional additional CSS class names */
  className?: string;
}

/**
 * Reusable loading indicator with the loading frog mascot.
 * Shows the hourglass frog with a gentle bounce animation and optional message.
 *
 * @example
 * <LoadingFrog message="Loading registration..." />
 * <LoadingFrog size="sm" fullScreen={false} />
 */
export function LoadingFrog({
  message,
  size = 'xl',
  fullScreen = true,
  className
}: LoadingFrogProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center',
        fullScreen && 'min-h-[60vh]',
        className
      )}
    >
      <FrogMascot variant="loading" size={size} className="animate-bounce-slow" />
      {message && (
        <p className="mt-3 text-sm text-muted-foreground animate-pulse">{message}</p>
      )}
    </div>
  );
}
